import { useEffect, useRef, RefObject } from 'react';

const useOutsideAlerter = <T extends HTMLElement>(onOutsideClick: () => void): RefObject<T> => {
  const ref = useRef<T>(null);

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      const dataPicker = document.querySelector('.p-datepicker');
      const dropdown = document.querySelector('.p-dropdown-panel');
      
      if (ref.current && !ref.current.contains(event.target as Node)) {
        if (!dataPicker?.contains(event.target as Node) && !dropdown?.contains(event.target as Node)) {
          onOutsideClick();
        }
      }
    }
    
    document.addEventListener('mousedown', handleClick);
   
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [onOutsideClick]);

  return ref;
}

export default useOutsideAlerter;